<template>
  <section>
    <b-card-group deck>
      <b-card no-body v-for="categories in documentCategories" :key="categories.id">
        <template v-slot:header>
          <b-row class="container-wrap">
            <b-col cols="11">
                <h6 class="position-text">{{ categories.name }}</h6>
            </b-col>
            <b-col cols="1">
                <b-button class="fa fa-plus position-text" variant="primary" size="sm" @click="onShowModal(categories.id)"></b-button>
            </b-col>
          </b-row>
        </template>
        <b-list-group class="scroll" flush>
          <b-list-group-item class="list-item" v-for="list in documentsLists.filter(x => x.documentCategoryId == categories.id)" :key="list.id">
            <i :class="'fa ' + (list.type.includes('image/') ? 'fa-image' : 'fa-file') + ' mr-2'"></i>
            {{ list.filename }}
            <i class="fa fa-eye ml-2 hover-btn" v-if="(list.type.includes('image/') || list.type.includes('pdf'))" @click="onView(list)"></i>
            <i class="fa fa-copy ml-2 hover-btn" @click="onDownloadFile(list)"></i>
            <i class="fa fa-trash ml-2 hover-btn" @click="onDeleteFile(list)"></i>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-card-group>

    <b-modal id="upload-document" ref="upload-document" size="sm" :title="'Upload Document'"
      :ok-title="isUploading ? 'Uploading' : 'Upload'" :ok-disabled="isUploading" @ok="onUploadFile" @show="filesUpload = []">
      <b-form-group label="Type">
        <b-form-select v-model="documentCategoryIdSelected">
          <option
            v-for="documentCategory in sortSelect(documentCategories)"
            :key="documentCategory.id"
            :value="documentCategory.id"
          >{{ documentCategory.name }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-file
        multiple
        v-model="filesUpload"
        :file-name-formatter="formatNames"
        :accept="fileTypes"
      ></b-form-file>
    </b-modal>
  </section>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  props: {
    partId: {
      type: [Number, String],
      default: 0,
    },
    reference: {
      type: String,
      default: null,
    },
    refId: {
      type: [Number, String],
      default: 0
    },
    clearListOnPart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filesUpload: [],
      documentCategoryIdSelected: 0,
      fileTypes: [
        '.txt',
        '.pdf',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.csv',
        '.ppt',
        '.pptx',
      ].join(', '),
      isUploading: false,
      imageCategoryId: 202,
      acceptedView: [
        'application/pdf',
        '.pdf'
      ]
    }
  },
  computed: {
    ...mapGetters('lookup', [
      'documentCategories',
    ]),
    ...mapGetters('parts', [
      'documentsLists',
    ]),
    imagesList() {
      return this.documentsLists.filter(x => x.documentCategoryId == this.imageCategoryId && x.type.includes('image/')).map(image => ({
        id: image.id,
        name: image.filename,
        url: image.virtualPath
      }));
    }
  },
  methods: {
    ...mapActions('parts', [
      'uploadDocuments',
      'getDocuments',
      'downloadDocument',
      'deleteDocument'
    ]),
    ...mapMutations('parts', ['setDocumentsList']),
    onShowModal(category) {
      this.$refs['upload-document'].show();
      this.documentCategoryIdSelected = category;
    },
    onUploadFile: async function(e) {
      if (this.filesUpload.length > 0) {
        try {
          this.isUploading = true;
          let formData = new FormData();
          this.filesUpload.forEach(element => {
            formData.append('files[]', element, element.name);
          });
          formData.append('partId', this.partId);
          formData.append('documentCategoryId', this.documentCategoryIdSelected);
          if (this.reference != null) {
            formData.append(this.reference, this.refId);
          }

          e.preventDefault();
          const result = await this.uploadDocuments(formData);
          this.$refs['upload-document'].hide();
          this.isUploading = false;
          if (result.status == 200)
            this.$snotify.success('Upload successful', 'Upload');

          this.onGetFiles();
        } catch (e) {
          this.isUploading = false;
        }
      } else {
        e.preventDefault();
        alert('No File Uploaded');
        return;
      }
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    async onGetFiles() {
      if (this.partId > 0) {
        let filtersObj = `{partId: ${this.partId}`
        if (this.reference != null && this.refId > 0) {
          filtersObj += `, ${this.reference}: ${this.refId}`
        }

        filtersObj += `}`

        await this.getDocuments(filtersObj);
        this.refreshImages();  
      }
      
    },
    async onDownloadFile(file) {
      const data = await this.downloadDocument(file.guid);

      const fileUrl = URL.createObjectURL(data);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = fileUrl;
      a.download = file.filename;
      a.click();
      window.URL.revokeObjectURL(fileUrl);
      document.body.removeChild(a);
    },
    onView(file) {
      console.log(file, 'Test')
      if (file.type.includes('image/')) {
        console.log('Showing');
        const ndx = this.imagesList.findIndex(x => x.id == file.id);

        this.$imageViewer.index(ndx);
        this.$imageViewer.show();
      } else {
        window.open(process.env.VUE_APP_API_URL + file.virtualPath, '_blank');
      }
    },
    refreshImages() {
      if (this.imagesList.length) {
        this.$imageViewer.images(this.imagesList);
      }
    },
    async onDeleteFile(file) {
      const deleteConfirmed = await this.openConfirmBox({
        message:'Are you sure you would like to delete the file ' + file.filename + '?',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
      });
      if (deleteConfirmed) {
        const result = await this.deleteDocument(file.id);
        if (result.status==200) {
          this.onGetFiles();
          this.$snotify.success('Delete successful', 'Delete');
        }
      }
    }
  },
  watch: {
    partId() {
      if(!this.partId && this.clearListOnPart) { this.setDocumentsList([]); }
      this.onGetFiles();
    },
    refId() {
      this.onGetFiles()
    }
  },
  mounted() {
    if(!this.partId && this.clearListOnPart) { this.setDocumentsList([]); }
    this.refreshImages();
  }
}
</script>

<style scoped>
  .scroll {
    max-height: 300px;
    overflow-y: auto;
  }
  .position-text {
    margin: 0;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
  .container-wrap {
    position: relative;
    height: 2em
  }
  .hover-btn {
    display:none;
  }

  .remove-padding {
    padding: 0rem !important
  }

  .list-item:hover .hover-btn {
    font-size: 12px;
    display: inline-block;
    cursor: pointer;
    color: #aaa;
    transition: color 0.3s;
  }
  .list-item {
    font-size: 12px;
    cursor: default;
    padding: 0.5rem 1rem !important;
  }
</style>
